import SetPasswordContainer from "../containers/SetPasswordContainer";

const SetPasswordPage = () => {
    return <SetPasswordContainer />;
};

export default SetPasswordPage;
